import { Component, Input, EventEmitter, Output} from '@angular/core';



/**
   * Logger Factory
   * @namespace item: title, subtitle and icon to shoow
   * <ute-generic-list-item [item]="item2"></ute-generic-list-item>
*/

@Component({
  selector: 'ute-generic-list-item',
  templateUrl: 'ute-generic-list-item.component.html'
})
export class UteGenericListItem  {
  @Input() item: any;
  @Output() itemSelected = new EventEmitter;

  constructor() {
    
  }
   
  ngOnInit() {
    
  }

  onClickItem(item){
    this.itemSelected.emit(item);
  }
 
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-generic-list-item/ute-generic-list-item.component.ts